import type { Pagination } from 'models';
import { useEffect, useState } from 'react';
import { useGivingsInfiniteQuery } from '../../../queries';
import type { GivingsListFilter } from '../../../types';

export const useGivings = ({
  allowUnfeatured,
  filter,
  pagination,
}: {
  allowUnfeatured?: boolean;
  filter?: GivingsListFilter;
  pagination: Omit<Pagination, 'position'>;
}) => {
  const [isFeatured, setIsFeatured] = useState(true);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
    setIsFeatured(true);
  }, [filter?.organizationId]);

  const query = useGivingsInfiniteQuery({
    filter: {
      featured: isFeatured,
      ...filter,
    },
    pagination,
  });

  useEffect(() => {
    if (isFeatured && allowUnfeatured && query.data?.pages[0]?.data.length === 0) {
      // eslint-disable-next-line react-hooks/set-state-in-effect -- TODO: fix later
      setIsFeatured(false);
    }
  }, [isFeatured, allowUnfeatured, query.data?.pages]);

  return { isFeatured, query };
};
